import * as Yup from "yup";
export const initialValues = (data) => {
  return {
    ...data,
    englishOptionType: data?.localized_data?.en?.name,
    arabicOptionType: data?.localized_data?.ar?.name,
  };
};
export const structure = (_, __, t) => [
  {
    head: "",
    width: "100%",
    list: [
      {
        name: `image`,
        kind: "upload",
        type: "file",
        label: t("common.image"),
        width: "100%",
      },

      {
        name: `englishOptionType`,
        kind: "input",
        type: "text",
        label: `${t("products_option_types.option_type_en")}*`,
        width: "47%",
      },
      {
        name: `arabicOptionType`,
        kind: "input",
        type: "text",
        label: `${t("products_option_types.option_type_ar")}*`,
        width: "47%",
      },
    ],
  },
];

export const validationSchema = () =>
  Yup.object({
    englishOptionType: Yup.string().required("required"),
    arabicOptionType: Yup.string().required("required"),
  });
